// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"15b416c7","243":"0a6c5ad1","453":"10bdb964","740":"064fff8e"}[chunkId] + ".chunk.js";
};